import FormErrorMessage from '@/app/common/components/FormErrorMessage'
import { currencyFormatter } from '@/app/common/utilities'
import { Label } from '@/shad/ui/label'
import { Control, Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { CurrencyInputField } from '../currency-input/currency-input'

interface PurseProps {
  paymentAmount: number
  name: string
  control: Control<any>
  errorMessage: string | undefined
  onFocus: () => void
}

export const PurseInput = ({
  paymentAmount,
  name,
  control,
  errorMessage,
  onFocus,
}: PurseProps) => {
  const { t: translate } = useTranslation()

  return (
    <div className="h-full ml-7">
      <div className="flex justify-start text-sm mb-4 text-gray-600 mt-2">
        {translate('how_much_of')} {currencyFormatter.format(paymentAmount)}{' '}
        {translate('would_you_like')} {translate('this_purse')}{' '}
        {translate('to_cover')}?
      </div>

      <div className="h-full">
        <Label>{translate('amount')}</Label>
        <div className="flex flex-col text-sm gap-2">
          <Controller
            control={control}
            name={name}
            render={({ field }) => (
              <CurrencyInputField
                id={name}
                value={field.value}
                onFocus={onFocus}
                onChange={(value) => {

                  field.onChange(value)
                }}
                aria-invalid={!!errorMessage}
                aria-describedby={errorMessage ? `${name}-error` : undefined}
              />
            )}
          />
          {errorMessage && (
            <div className="">
              <FormErrorMessage message={errorMessage} />
            </div>
          )}
          <Controller
            control={control}
            name={name}
            render={({ field }) => (
              <div className="text-gray-600">
                {field.value
                  ? ((field.value * 100) / Number(paymentAmount)).toFixed(2)
                  : 0}
                %
              </div>
            )}
          />
        </div>
      </div>
    </div>
  )
}